module.exports = __webpack_public_path__ + "img/7.bc128fb9.png";